import * as React from 'react';
import { RatingBar } from '../RatingBar';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { setColorByRating } from '../../../../utils/reviews';
import { CategoryRu } from '../../../../models/hotel-reviews';

export interface CategoryRatingShortProps {
    category: CategoryRu;
    rating: number | null;
}

interface StyledCategoryRatingShortProps
    extends JSSClassesProps<ComponentJSSClasses>,
        CategoryRatingShortProps {}

export function CategoryRatingShort(props: StyledCategoryRatingShortProps) {
    const { classes, category, rating } = props;

    return (
        <div className={classes.container}>
            <div className={`${classes.rightSide} ${rating ? '' : classes.withoutRating}`}>
                <RatingBar rating={rating ?? 0} size={'S'} />
                <div className={classes.textContent}>
                    <p className={classes.category}>{category}</p>
                    <p
                        className={classes.reviewCount}
                        style={{ color: setColorByRating(Number(rating)) }}
                    >
                        {rating ? Math.round(rating) : '-'}
                    </p>
                </div>
            </div>
        </div>
    );
}
